import React from "react";
import { Button, GridItem } from "@chakra-ui/react";
import { UseFormSetError } from "react-hook-form";
import { AnyObjectSchema } from "yup";
import { Form, PasswordInputs, Grid, Select, TextInput } from "components";
import { USER_ROLES } from "./duck";

interface UserFormProps<TValues> {
  onSubmit(data: TValues, setError: UseFormSetError<TValues>): Promise<any>;
  onClose: () => void;
  defaultValues?: TValues;
  validationSchema: AnyObjectSchema;
}

const UserForm: React.FC<UserFormProps<any>> = ({
  onSubmit,
  onClose,
  defaultValues,
  validationSchema
}) => {
  return (
    <>
      <Form
        validationSchema={validationSchema}
        defaultValues={defaultValues}
        onSubmit={onSubmit}
      >
        <Grid
          templateColumns={{
            lg: "repeat(1, 1fr)"
          }}
        >
          <GridItem>
            <TextInput
              name="firstName"
              label="First Name"
              placeholder="First Name"
            />
          </GridItem>
          <GridItem>
            <TextInput
              name="lastName"
              label="Last Name"
              placeholder="Last Name"
            />
          </GridItem>
          <GridItem>
            <TextInput name="email" label="Email" placeholder="Email" />
          </GridItem>
          <GridItem>
            <Select
              name="userRole"
              label="Role"
              placeholder="Select Role"
              options={USER_ROLES}
            />
          </GridItem>
          <PasswordInputs />
          <GridItem>
            <TextInput
              type="password"
              numeric
              name="pin"
              label="PIN"
              placeholder="PIN"
            />
          </GridItem>
        </Grid>
        <Form.Controls submitText="Save">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
        </Form.Controls>
      </Form>
    </>
  );
};

export default UserForm;
